// Mixin para limpar folderATUAL quando o componente é fechado/destruído
export default {
  beforeRouteLeave(to, from, next) {
    // Zerar folderATUAL quando sair da rota
    console.log('Saindo da rota - zerando folderATUAL')
    this.clearFolderATUAL()
    next()
  },
  
  mounted() {
    // Adicionar listener para quando a página for fechada/recarregada
    window.addEventListener('beforeunload', this.clearFolderATUAL)
  },
  
  beforeDestroy() {
    // Limpar folderATUAL quando o componente for destruído
    console.log('Componente sendo destruído - zerando folderATUAL')
    this.clearFolderATUAL()
    
    // Remover listeners para evitar memory leaks
    window.removeEventListener('beforeunload', this.clearFolderATUAL)
  },
  
  methods: {
    clearFolderATUAL() {
      localStorage.setItem('folderATUAL', JSON.stringify(0))
      
      if (this.$store) {
        this.$store.commit('Folders/setfolderAtual', {
          id: 0,
          folder_name: 'Meus Videos',
          folder_backet_adress: null,
          id_main: null,
          id_user: this.getUserData ? this.getUserData.id : null,
          folder_date: null,
          folder_key_name: null,
        })
      }
    },
  },
}
